/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import community_icon from "../../../../images/Oscar.svg";
import PaginationComponent from "../../../Pagination/pagination";
import Chip from "@mui/material/Chip";
import {
  fetchAllCities,
  fetchSubscribedVendorApi,
  vendorCancelSubscriptionApi,
} from "../../../../Services/Vendor/VendorApi/VendorApi";
import { useSelector, useDispatch } from "react-redux";
import { capitalizeWords } from "../../../../Utils/LetterCase";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import { fetchProfileData } from "../../../../Services/Profile/ProfileApi";
import { VendorSubscriptionModal } from "../../../Vendor/Vendor Subscription/PurchaseSubscriptionModal";

const RealtorDirectoryListing = () => {
  const dispatch = useDispatch();
  const userType = localStorage.getItem("user_type");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [count, setCount] = useState(0);
  const [id, setId] = useState("");
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const userId = localStorage.getItem("user_id");
  const [showModal, setShowModal] = useState(false);
  const [selectedSub, setSelectedSub] = useState(null);
  const [price, setPrice] = useState(null);
  const [subType, setSubType] = useState("");

  const { data: profileData } = useSelector((state) => state.fetchProfileData);

  const { data } = useSelector((state) => state.fetchAllCities);

  const vendors = useSelector((state) => state.vendorSubscribed.data);
  const { data: productList } = useSelector((state) => state.fetchProductList);

  useEffect(() => {
    dispatch(
      fetchAllCities({ page: page, page_size: pageSize, search: search })
    );
  }, [dispatch, page, pageSize, search]);

  useEffect(() => {
    setCount(data?.data?.count);
  }, [data?.data?.count]);

  useEffect(() => {
    dispatch(fetchSubscribedVendorApi(userId));
  }, [dispatch, userId]);

  useEffect(() => {
    if (productList?.data?.length > 0) {
      const product = productList.data.find(
        (item) => item.metadata.Type.name === "dir_listing"
      );
      setPrice(product?.default_price?.unit_amount);
      setSubType(product?.name);
    }
  }, [productList, userType]);

  const handleOpenModal = (sub) => {
    setSelectedSub(sub);
    setShowModal(true);
  };

  const handleCancelSubscription = () => {
    if (selectedSub) {
      const payload = {
        user_id: userId,
        ...(profileData?.data?.is_super_subscribed
          ? { record_id: selectedSub.id }
          : {
              subscription_id: selectedSub.stripe_subscription_id,
              city_id: selectedSub.city_id,
            }),
      };

      dispatch(vendorCancelSubscriptionApi(payload)).then((res) => {
        if (res?.payload?.status === 200) toast.success(res?.payload?.message);
        else toast.error(res?.payload?.message);
        dispatch(fetchSubscribedVendorApi(userId));
        dispatch(fetchProfileData(userId));
      });
      setShowModal(false);
    }
  };

  return (
    <div>
      <div className="community-section">
        <div className="community-inner-wrap">
          <div className="add-new-community d-flex justify-content-between align-items-start flex-column">
            <div className="w-100 d-flex align-items-center justify-content-between subscription-area-blk">
              <div className="community-heading">Vendor Directory Listing</div>
              <div className="category-block "></div>
            </div>
            <div className="expert-title">
              Unlock Exclusive Access to Vendor Directory Listing.
            </div>
          </div>
          <div className="community-name-table">
            <div className="community-tabs-section d-none"></div>
            <div className="training-ai-blk">
              <div className="tab-content mt-3">
                <div className="contact-content  mt-4 training-ai-block">
                  <div className="contact-us-block-form text-start">
                    <div className="table-inner">
                      <table className="table table-borderless">
                        <thead className="exp-sub-heading">
                          <tr>
                            <th scope="col">City</th>
                            <th scope="col">State</th>
                            {/* <th scope="col">Zipcode</th> */}
                            <th scope="col">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {vendors?.length > 0 ? (
                            vendors?.map((sub, index) => (
                              <tr key={sub?.id}>
                                <td>{capitalizeWords(sub?.city)}</td>
                                <td>{sub?.state}</td>
                                {/* <td>{sub?.zip_code}</td> */}
                                <td>
                                  {sub?.payment_status !== "30days_trial" && (
                                    <button
                                      className="orange-filled-btn claimbtn cancel-realtors"
                                      onClick={() => handleOpenModal(sub)}
                                      disabled={
                                        sub?.payment_status === "30days_trial"
                                      }
                                    >
                                      Cancel
                                    </button>
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              {profileData?.data?.is_trial_activated ? (
                                <td>No active subscription</td>
                              ) : (
                                <td colSpan="8">
                                  🏡 💼 Your path to growth begins now!
                                  Subscribe to a city and enjoy a 30-day free
                                  trial on us!
                                </td>
                              )}
                            </tr>
                          )}
                        </tbody>
                      </table>
                      <div>
                        <Modal
                          show={showModal}
                          onHide={() => setShowModal(false)}
                          size="sm"
                          centered
                        >
                          <Modal.Header className="d-flex justify-content-center">
                            <Modal.Title className="fw-bold">
                              Cancel Subscription
                            </Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <div className="text-center">
                              <p className="text-muted">
                                Are you sure you want to cancel your
                                subscription for <b>{selectedSub?.city}</b>?
                              </p>
                            </div>
                          </Modal.Body>
                          <Modal.Footer className="d-flex justify-content-between">
                            <button
                              className="bttn-close"
                              onClick={() => setShowModal(false)}
                            >
                              No, Keep It
                            </button>
                            <button
                              className="bttn-upload"
                              onClick={handleCancelSubscription}
                            >
                              Cancel
                            </button>
                          </Modal.Footer>
                        </Modal>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="all-commmunities-table">
          <div className="inner-wrap-all">
            <div className="title-search-block d-flex justify-content-between flex-column">
              <div className="d-flex justify-content-between">
                <div className="community-heading">Find a City</div>
                <div className="">
                  {subType && <Chip color="primary" label={subType} />}{" "}
                  {price && (
                    <Chip color="success" label={price ? `$${price}` : "N/A"} />
                  )}
                </div>
              </div>
              <div className="community-searchbar-main">
                <div className="inner-searchbar mt-3">
                  <div className="input-searchbar loader-block">
                    <input
                      type="search"
                      value={search}
                      onChange={(e) => {
                        const value = e.target.value;
                        setSearch(value);
                      }}
                      placeholder="Search by City Name"
                    />
                    <div className="owl_logo_searchbar">
                      <a href="#">
                        <img
                          src={community_icon}
                          alt="owl_logo"
                          width="20"
                          height="20"
                        ></img>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="community-name-table communityblk">
              <div className="table-inner">
                <table className="table table-borderless">
                  <thead className="exp-sub-heading">
                    <tr>
                      <th scope="col">City</th>
                      <th scope="col">State</th>
                      {/* <th scope="col">Zipcode</th> */}
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.data?.data?.length > 0 ? (
                      data?.data?.data?.map((city, index) => (
                        <tr key={city?.id}>
                          <td>{city.city}</td>
                          <td>{city.state}</td>
                          {/* <td>{city.zip_code || "N/A"}</td> */}
                          <td>
                            <button
                              className="btn-submit-claim unsubscribe"
                              onClick={() => {
                                setId(city?.id);
                                setShowSubscriptionModal(true);
                              }}
                            >
                              Subscribe
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4">No cities available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <PaginationComponent
                  count={count}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  page={page}
                  setPage={setPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <VendorSubscriptionModal
        show={showSubscriptionModal}
        id={id}
        onHide={() => {
          setTimeout(() => {
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          }, 200);
          setShowSubscriptionModal(false);
        }}
      />
    </div>
  );
};

export default RealtorDirectoryListing;
